import { render, staticRenderFns } from "./groupManagement.vue?vue&type=template&id=55827a85&scoped=true"
import script from "./groupManagement.vue?vue&type=script&lang=js"
export * from "./groupManagement.vue?vue&type=script&lang=js"
import style0 from "./groupManagement.vue?vue&type=style&index=0&id=55827a85&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55827a85",
  null
  
)

export default component.exports